import React from 'react';
import useFindKeySkills from '../../../hooks/useFindKeySkills';
import HiddenList from '../HiddenList';
import { Spin } from 'antd';
import ASTPagination from '../ASTPagination';

const HiddenKeySkillMoves = () => {
  const { data, isFetching, meta, page, setPage } = useFindKeySkills();

  const totalPages = Math.ceil(meta?.total / meta?.limit);

  return (
    <Spin
      spinning={isFetching}
      style={{
        width: '100%',
      }}
    >
      <HiddenList data={data} />
      <div
        style={{
          marginBottom: '10px',
        }}
      />
      <ASTPagination
        maxPage={totalPages}
        currentPage={page}
        setCurrentPage={setPage}
        limit={meta?.limit || 1}
      />
    </Spin>
  );
};

export default HiddenKeySkillMoves;
